import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { OccurrenceCount } from '../types';

interface UserUploadChartProps {
    data: OccurrenceCount[];
}

const UserUploadChart: React.FC<UserUploadChartProps> = ({ data }) => {
    const sortedData = [...data].sort((a, b) => b.occurrence - a.occurrence);

    // Transform the sorted data to the format Nivo expects
    const chartData = sortedData.map((item) => ({
        id: item.name,
        label: item.label,
        value: item.occurrence,
    }));

    return (
        <div className="chart">
            <ResponsiveBar
                data={chartData}
                indexBy="id"
                keys={['value']}
                margin={{ top: 20, right: 10, bottom: 30, left: 120 }}
                padding={0.3}
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                enableGridX={true}
                colors={['#e5b611']} // Set custom color here
                layout="horizontal" // Change to horizontal layout
                borderColor={{
                    from: 'color',
                    modifiers: [['darker', 1.6]],
                }}
                borderRadius={10}
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legendPosition: 'middle',
                    legendOffset: 32,
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legendPosition: 'middle',
                    legendOffset: -40,
                    renderTick: (tick) => {
                        const item = data.find((d) => d.name === tick.value);
                        return (
                            <g transform={`translate(${tick.x},${tick.y})`}>
                                <line stroke="#000" strokeWidth={1} x2={-6} />
                                <text
                                    textAnchor="end"
                                    dominantBaseline="middle"
                                    transform="translate(-10,0)"
                                    style={{
                                        fontSize: 11,
                                        fill: '#333',
                                        fontFamily: 'Lato bold',
                                    }}
                                >
                                    {item ? item.label : tick.value}
                                </text>
                            </g>
                        );
                    },
                }}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{
                    from: 'color',
                    modifiers: [['brighter', 4]],
                }}
                legends={[]}
                role="application"
                ariaLabel="Occurrence count bar chart"
                barAriaLabel={(e) => `${e.id}: ${e.value} occurrences`}
                theme={{
                    grid: {
                        line: {
                            stroke: '#dddddd',
                            strokeWidth: 1,
                        },
                    },
                    tooltip: {
                        container: {
                            background: '#333',
                            color: '#fff',
                            fontSize: 12,
                            borderRadius: 2,
                            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
                            padding: '5px 9px',
                        },
                    },
                }}
                tooltip={({ id, value, label }) => {
                    const item = data.find(
                        (d) => `value - ${d.name}` === label,
                    );
                    return (
                        <div
                            style={{
                                padding: 12,
                                color: '#fff',
                                background: '#333',
                            }}
                        >
                            <span style={{ display: 'block', marginBottom: 4 }}>
                                <strong>{item ? item.label : id}</strong>
                            </span>
                            <span style={{ display: 'block' }}>
                                Reviews: <strong>{value}</strong>
                            </span>
                        </div>
                    );
                }}
            />
        </div>
    );
};

export default UserUploadChart;
